import { pureObject } from '@/utils';
import { create } from 'zustand';

/** 环境变量最终收集到的数据结构可能情况 */
export interface EnvItem {
  /** 环境变量类型 */
  type: 'custom' | 'configMapKeyRef' | 'secretKeyRef';
  /** 键 */
  key: string;
  /** 值 */
  value?: string;
  /** 资源 */
  resource?: string;
  /** 资源中的键 */
  resourceKey?: string;
}

interface EnvironmentVarState {
  /** 是否勾选了环境变量 */
  isEnvironmentVarSelected: boolean;
  /** 环境变量数据 */
  env?: EnvItem[];
  /** 校验函数 */
  validateEnv?: () => Promise<boolean>;
}

const initEnvironmentVarState: EnvironmentVarState = {
  isEnvironmentVarSelected: false,
  env: undefined,
};

interface EnvironmentVarAction {
  toggleEnvironmentVarSelected: (selected: boolean) => void;
  /** 更新环境变量 */
  updateEnv: (env: EnvItem[]) => void;
  /** 批量引用环境变量 */
  bulkUpdateEnv: (env: EnvItem[]) => void;
  /** 设置校验函数 */
  setValidateEnv: (validate: () => Promise<boolean>) => void;
  /** 重置 */
  reset: () => void;
}

export const useEnvironmentVarStore = create<EnvironmentVarState & EnvironmentVarAction>()(
  (set) => ({
    ...initEnvironmentVarState,
    toggleEnvironmentVarSelected: (selected) => set({ isEnvironmentVarSelected: selected }),
    updateEnv: (env) =>
      set({
        env: env?.map((item) => {
          return pureObject(item); // 净化对象,去除空值字段
        }),
      }),
    bulkUpdateEnv: (env) =>
      set((state) => ({
        env: [...(state.env || []), ...env].map((item) => {
          return pureObject(item); // 净化对象,去除空值字段
        }),
      })),
    setValidateEnv: (validate) => set({ validateEnv: validate }),
    reset: () => set(initEnvironmentVarState),
  }),
);
